import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBookingCommentResponse, IBookingResponse } from "../../Orchestrator/Types/Index";

export async function getBookingCommentAPI(bookingId: string): Promise<IApiResponse<IBookingCommentResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.getBookingComment(bookingId)}`;
    return await apiRequest<IBookingCommentResponse>(endpoint, 'GET');
}
